<template>
<div class="tab-inner" v-show="isShown">
  <slot />
</div>
</template>


<script>
export default {
  props: ["name"],
  data: ()=>({
    tabContainer: null,
  }),
  computed: {
    isShown() {
      if (!this.tabContainer)
        return true;
      var activeTab=this.tabContainer.tabs[this.tabContainer.activeTab];
      return activeTab==this;
    },
  },
  mounted() {
    var component=this;
    while(component) {
      if (component.tabsRegisterInner) {
        this.tabContainer=component;
        this.tabContainer.tabsRegisterInner(this);
        break;
      }
      component=component.$parent;
    }
  },
  beforeUnmount() {
    if (this.tabContainer)
      this.tabContainer.tabsUnregisterInner(this);
  },
}
</script>
